import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mask',
})
export class MaskPipe implements PipeTransform {
  public transform(value: string | null): string {
    if (!value) {
      return '';
    }

    return '*'.repeat(value.length);
  }
}
